<template>
  <div class="container mt-4 mb-5">
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <div class="card shadow">
          <div class="card-header bg-primary text-white">
            <h4 class="mb-0">{{ copy.title }}</h4>
          </div>
          <div class="card-body">
            <div class="row mb-0 border-bottom" v-for="row in rows" :key="row.label">
              <div class="col-md-3 py-3 border-end">
                <strong>{{ row.label }}</strong>
              </div>
              <div class="col-md-9 py-3">
                <template v-if="row.type === 'html'">
                  <span v-html="row.value"></span>
                </template>
                <template v-else-if="row.type === 'list'">
                  <ul class="list-unstyled mb-0">
                    <li v-for="item in row.items" :key="item">{{ item }}</li>
                  </ul>
                  <small v-if="row.note" class="text-muted">{{ row.note }}</small>
                </template>
                <template v-else-if="row.type === 'policy'">
                  <div class="mb-3">
                    <strong class="text-primary">{{ row.customerTitle }}</strong>
                    <ul class="list-unstyled mt-2">
                      <li v-for="item in row.customerItems" :key="item">{{ item }}</li>
                    </ul>
                  </div>
                  <div>
                    <strong class="text-primary">{{ row.defectTitle }}</strong>
                    <ul class="list-unstyled mt-2">
                      <li v-for="item in row.defectItems" :key="item" v-html="item"></li>
                    </ul>
                  </div>
                </template>
                <template v-else>
                  <span>{{ row.value }}</span>
                </template>
              </div>
            </div>

            <div class="text-center mt-4">
              <router-link to="/forwriting/signin" class="btn btn-primary">
                {{ copy.back }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, watchEffect} from "vue";
import {useI18n} from "vue-i18n";

const { locale } = useI18n();

const jaCopy = {
  pageTitle: "特定商取引法に基づく表記 - ForWriting",
  title: "特定商取引法に基づく表記",
  companyNameLabel: "法人名",
  companyName: "株式会社ＧｉｔＨｏｕｓｅ",
  operatorLabel: "オペレーション責任者",
  operatorName: "松永 尚人",
  addressLabel: "住所",
  address: "〒169-0075 東京都新宿区高田馬場3丁目2－14<br>天翔高田馬場ビル310",
  phoneLabel: "電話番号",
  phone: "050-1790-6014（受付時間：平日10:00〜18:00）",
  emailLabel: "メールアドレス",
  priceLabel: "価格",
  priceItems: [
    "• 月額基本利用料：35,000円（税込）",
    "• 600ポイントまで含む。",
    "• 超過分は1ポイントあたり50円（税込）加算。",
    "• 例）800ポイント利用時：35,000円＋(200×50円)＝45,000円（税込）",
    "• 継続課金：毎月自動更新（解約はいつでも可能）",
  ],
  priceNote: "※詳細は各商品・サービスページに記載",
  additionalFeeLabel: "追加手数料",
  additionalFee: "・銀行振込手数料：お客様負担",
  paymentMethodLabel: "受け付け可能な決済手段",
  paymentMethod: "クレジットカード決済、国内銀行振込",
  paymentPeriodLabel: "決済期間",
  paymentPeriodItems: [
    "• クレジットカード決済：ご注文時に即時決済",
    "• 銀行振込：注文から3日以内にお振込みください",
  ],
  deliveryLabel: "配達時間",
  delivery: "• サービス利用開始：決済完了後、即時利用可能",
  returnPolicyLabel: "交換および返品に関するポリシー",
  customerReturnTitle: "＜お客様からの返品・交換＞",
  customerReturnItems: [
    "• サービスの特性上、利用開始後の返金・キャンセルは原則不可",
    "• 契約前のキャンセル：契約締結前であればキャンセル可能",
  ],
  defectReturnTitle: "＜不良品・サービスの返品・交換＞",
  defectReturnItems: [
    "• 提供内容に不備がある場合は、速やかに弊社サポート（<a href=\"mailto:marketing@git-house.com\">marketing@git-house.com</a>または050-1790-6014）へご連絡ください",
    "• 内容確認後、弊社負担で再提供または返金対応を行います",
  ],
  quantityLabel: "注文可能な量",
  quantity: "特に制限なし",
  applicationPeriodLabel: "申し込み期間",
  applicationPeriod: "銀行振込の場合は注文から3日以内にお支払いください",
  environmentLabel: "動作環境",
  environment: "本サービスは最新のGoogle Chrome、Safari、Microsoft Edgeの最新版でのご利用を推奨します",
  back: "戻る",
}

const twCopy = {
  pageTitle: "特定商業交易法資訊 - ForWriting",
  title: "特定商業交易法資訊",
  companyNameLabel: "法人名稱",
  companyName: "GitHouse 株式會社",
  operatorLabel: "營運負責人",
  operatorName: "松永 尚人",
  addressLabel: "地址",
  address: "〒169-0075 東京都新宿區高田馬場3丁目2－14<br>天翔高田馬場大樓310",
  phoneLabel: "電話號碼",
  phone: "050-1790-6014（受理時間：平日 10:00〜18:00）",
  emailLabel: "電子郵件地址",
  priceLabel: "價格",
  priceItems: [
    "• 月費基本方案：35,000 日圓（含稅）",
    "• 包含最多 600 點。",
    "• 超出部分每點加收 50 日圓（含稅）。",
    "• 例）使用 800 點時：35,000 日圓＋(200×50 日圓)＝45,000 日圓（含稅）",
    "• 持續扣款：每月自動續約（可隨時解約）",
  ],
  priceNote: "※ 詳細內容請參閱各商品／服務頁面",
  additionalFeeLabel: "追加手續費",
  additionalFee: "・銀行匯款手續費由顧客負擔",
  paymentMethodLabel: "可接受的付款方式",
  paymentMethod: "信用卡付款、國內銀行匯款",
  paymentPeriodLabel: "付款時間",
  paymentPeriodItems: [
    "• 信用卡付款：下單時立即付款",
    "• 銀行匯款：請於下單後 3 日內完成匯款",
  ],
  deliveryLabel: "交付時間",
  delivery: "• 服務開始使用：付款完成後即可立即使用",
  returnPolicyLabel: "關於換貨與退貨之政策",
  customerReturnTitle: "＜顧客主動申請退換＞",
  customerReturnItems: [
    "• 由於服務特性，開始使用後原則上不可退款或取消",
    "• 合約成立前可取消申請",
  ],
  defectReturnTitle: "＜瑕疵商品／服務之退換＞",
  defectReturnItems: [
    "• 若提供內容有缺失，請盡速聯繫本公司客服（<a href=\"mailto:marketing@git-house.com\">marketing@git-house.com</a> 或 050-1790-6014）",
    "• 確認內容後，本公司將負擔費用進行重新提供或退款處理",
  ],
  quantityLabel: "可訂購數量",
  quantity: "無特別限制",
  applicationPeriodLabel: "申請期間",
  applicationPeriod: "若採銀行匯款，請於下單後 3 日內完成付款",
  environmentLabel: "建議使用環境",
  environment: "本服務建議使用最新版的 Google Chrome、Safari、Microsoft Edge。",
  back: "返回",
}

const copy = computed(() => (locale.value === "tw" ? twCopy : jaCopy));

const rows = computed(() => [
  { label: copy.value.companyNameLabel, value: copy.value.companyName },
  { label: copy.value.operatorLabel, value: copy.value.operatorName },
  { label: copy.value.addressLabel, type: "html", value: copy.value.address },
  { label: copy.value.phoneLabel, value: copy.value.phone },
  { label: copy.value.emailLabel, type: "html", value: '<a href="mailto:marketing@git-house.com">marketing@git-house.com</a>' },
  { label: copy.value.priceLabel, type: "list", items: copy.value.priceItems, note: copy.value.priceNote },
  { label: copy.value.additionalFeeLabel, value: copy.value.additionalFee },
  { label: copy.value.paymentMethodLabel, value: copy.value.paymentMethod },
  { label: copy.value.paymentPeriodLabel, type: "list", items: copy.value.paymentPeriodItems },
  { label: copy.value.deliveryLabel, value: copy.value.delivery },
  {
    label: copy.value.returnPolicyLabel,
    type: "policy",
    customerTitle: copy.value.customerReturnTitle,
    customerItems: copy.value.customerReturnItems,
    defectTitle: copy.value.defectReturnTitle,
    defectItems: copy.value.defectReturnItems,
  },
  { label: copy.value.quantityLabel, value: copy.value.quantity },
  { label: copy.value.applicationPeriodLabel, value: copy.value.applicationPeriod },
  { label: copy.value.environmentLabel, value: copy.value.environment },
]);

watchEffect(() => {
  document.title = copy.value.pageTitle;
});
</script>

<style scoped>
.card {
  border: none;
  border-radius: 15px;
}

.card-header {
  border-radius: 15px 15px 0 0 !important;
  border: none;
}

.text-primary {
  color: #0d6efd !important;
}

hr {
  margin: 2rem 0;
}

.list-unstyled li {
  margin-bottom: 0.5rem;
}

.btn {
  border-radius: 25px;
  padding: 10px 30px;
}
</style> 